import React from 'react'
import SpaceBetween from '@cloudscape-design/components-themed/space-between'

// https://cloudscape.design/components/space-between
export function RadSpaceBetween ({ ...rest }) {
  return (
    <SpaceBetween {...rest} />
  )
}
